document.addEventListener("DOMContentLoaded", () => {
    const productID = document.querySelector('input[name="product-id"').getAttribute('value')
    console.log('productID', productID)

    fetch(
        `https://api-cdn.yotpo.com/v1/widget/Pe0CUIPrfIdAsyxfyzF0xIQMbieGZmhRKHqqvQ69/products/${productID}/reviews.json`
      )
        .then((response) => response.json())
        .then((reviews) => {
            const reviewCount = reviews.response.bottomline.total_review;
            if (reviewCount) {
              const reviewsContainer = document.querySelector('.no-highlight-review-container')
              const allReviewsButton = document.querySelector('.all-reviews-button-highlight')
              if(reviewsContainer) {
                reviewsContainer.style.display = "flex";
              }
              if (allReviewsButton) {
                allReviewsButton.style.display = "block";
                allReviewsButton.text = `See all Reviews (${reviewCount})`
              }
            }
        })
})
